<template>
  <!--
    cas-ba04: the Home hills and sun are the PAGE background (Ben), drawn by the
    layout across the whole window, under the docked sidebar and its avatar
    block too (Daniel). Anchored to the bottom of the page, not the viewport, so
    a long Home (Dive back in, recents) scrolls above the hills instead of over
    them. Decorative only: aria-hidden, never takes a pointer, behind all content.
  -->
  <div
    class="home-scene"
    :class="{ 'home-scene--plate': plate, 'home-scene--plate-seamless': plate && seamless }"
    aria-hidden="true"
  >
    <svg class="home-scene__wave" viewBox="0 0 1440 320" preserveAspectRatio="none">
      <!--
        Mountain silhouette: taller left peak, valley, lower right ridge —
        proportions from the home-scene mockup (peaks ~half the scene height).
      -->
      <path
        fill="currentColor"
        d="M0 210 C 80 190, 160 70, 300 48 C 420 30, 500 110, 620 175 C 760 250, 880 235, 1020 175 C 1160 115, 1280 175, 1440 255 L 1440 320 L 0 320 Z"
      />
      <path
        fill="currentColor"
        opacity="0.72"
        d="M0 245 C 140 220, 260 145, 400 130 C 560 110, 680 200, 820 230 C 980 265, 1140 210, 1280 230 C 1360 240, 1400 265, 1440 280 L 1440 320 L 0 320 Z"
      />
    </svg>
    <img class="home-scene__sun" :src="homeSun" alt="" />
  </div>
</template>

<script setup lang="ts">
import homeSun from '~/assets/images/home-sun.png';

defineProps<{
  /** A contained specimen plate (the /dev brand showcase), not the page background. */
  plate?: boolean;
  /** A plate whose hills sit directly on its parent's surface. */
  seamless?: boolean;
}>();
</script>

<style scoped>
/* Every value is a DESIGN.md token (--g-scene-*, --g-radius-*, --g-bg-*). */
.home-scene {
  height: var(--g-scene-height);
  inset: auto 0 0;
  overflow: hidden;
  pointer-events: none;
  position: absolute;
  z-index: -1;
}

.home-scene--plate {
  background: var(--g-bg-canvas);
  border-radius: var(--g-radius-control);
  height: var(--g-scene-plate-height);
  position: relative;
  width: 100%;
  z-index: auto;
}

.home-scene--plate-seamless {
  background: none;
  border-radius: 0;
}

.home-scene__wave {
  bottom: 0;
  color: var(--g-scene-hill);
  height: var(--g-scene-wave-height);
  left: 0;
  position: absolute;
  width: 100%;
}

.home-scene__sun {
  bottom: 0;
  display: block;
  height: auto;
  position: absolute;
  right: 0;
  width: var(--g-scene-sun-width);
}

.home-scene--plate .home-scene__wave {
  height: 72%;
}

.home-scene--plate .home-scene__sun {
  height: 70%;
  max-width: none;
  object-fit: cover;
  object-position: right bottom;
  width: auto;
}
</style>
